
















































import DeviceInfo from "@/models/deviceInfo.model";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
  }
})
export default class Map extends Vue {
  @Prop()
  private centerLocation: any;

  @Prop({ default: () => [] })
  private markers?: [];

  @Prop({ default: 7 })
  private zoomLevel?: number;

  private infoWindowPos = null;
  private infoWinOpen = false;
  private currentMidx = 0;
  private openedItem = null;

  private navigateToDevice(route: string) {
    this.$router.push(route);
  }

  private toggleInfoWindow(marker: any, idx: number) {
    this.openedItem = marker;
    this.infoWindowPos = marker.position;
    // check if its the same marker that was selected if yes toggle
    if (this.currentMidx === idx) {
      this.infoWinOpen = !this.infoWinOpen;
    } else {
      this.infoWinOpen = true;
      this.currentMidx = idx;
    }
  }
}
